import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getClientDashboardServices, getAppointmentNotesDashboard } from "../slice/clientPanelDashboardSlice";
import axios from "axios";

const ClientDashboardMain = () => {
  const dispatch = useDispatch();
  const { clientsServices, loading, appointmentNotes, aiReport, loadingNotes, noAppointment } = useSelector((state) => state.clientDashboard);

  const [selectedService, setSelectedService] = useState("");
  // const [appointmentNotes, setAppointmentNotes] = useState([]); // raw notes
  // const [aiReport, setAiReport] = useState(null); // AI JSON summary
  // const [loadingNotes, setLoadingNotes] = useState(false);
  // const [noAppointment, setNoAppointment] = useState(false);

  const clientToken = localStorage.getItem("client_access_token");

  // Fetch services on mount
useEffect(() => {
  dispatch(getClientDashboardServices(clientToken));
}, [dispatch, clientToken]);

// ✅ Auto-select first service when services load
useEffect(() => {
  if (!loading && clientsServices?.length > 0 && !selectedService) {
    setSelectedService(clientsServices[0].id);
  }
}, [loading, clientsServices]);

// ✅ Fetch notes when service changes
useEffect(() => {
  if (!selectedService) return;

  dispatch(
    getAppointmentNotesDashboard({
      clientToken,
      serviceId: selectedService,
    })
  );
}, [selectedService]);


// console.log("report", aiReport);

  return (
    <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
      <div className="ps-2 ps-lg-4">
        <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 border-bottom pb-3 montserrat">
          Dashboard
        </h4>

        {/* ✅ Dropdown To Select Service */}
        <div className="mb-4">
          <label className="fw-bold mb-2">Select Service:</label>
          {loading ? (
            <p>Loading services...</p>
          ) : (
            <select
              className="form-select"
              value={selectedService}
              onChange={(e) => setSelectedService(e.target.value)}
            >
              <option value="">-- Select Service --</option>
              {clientsServices?.map((service) => (
                <option key={service.id} value={service.id}>
                  {service?.serviceProviderPay?.service_name}
                </option>
              ))}
            </select>
          )}
        </div>

        {/* ✅ Show appointment notes while testing */}
        {/* {selectedService && (
          <div className="card shadow-sm mb-3 p-3">
            <h5>Sessions for Selected Service</h5>
            {loadingNotes ? (
              <p>Loading session notes...</p>
            ) : appointmentNotes.length === 0 ? (
              <p>No session notes found</p>
            ) : (
              <ul>
                {appointmentNotes.map((note, i) => (
                  <li key={i}>
                    {note.date_of_appointment} — {note.present} — {note.notes}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )} */}
        {noAppointment ? (
  <div className="text-center py-4 text-danger fw-bold">
    No appointment notes found ⚠️
  </div>
) : !aiReport ? (
  <div className="text-center py-4">
    <div className="spinner-border"></div>
    <p className="mt-2">Generating child progress report...</p>
  </div>
) : (
  <>

        {/* ✅ Report Section */}
        <div className="form-section mt-3">
          <h2 className="text-2xl font-bold mb-4">Child Progress Report 📑</h2>

          {/* Progress, Attendance, Trend */}
          <div className="row g-4">
            <div className="col-md-4"><div className="card p-3 shadow-sm"><h6>Overall Progress</h6><p>{aiReport.progress_level}</p></div></div>
            <div className="col-md-4"><div className="card p-3 shadow-sm"><h6>Attendance</h6><p>{aiReport.attendance_summary}</p></div></div>
            <div className="col-md-4"><div className="card p-3 shadow-sm"><h6>Weekly Progress Trend</h6><span className="text-success fw-bold">▲ {aiReport.weekly_trend}</span></div></div>
          </div>

          {/* Strengths & Improvements */}
          <div className="row mt-4 g-4">
            <div className="col-md-6"><div className="card p-3 shadow-sm"><h5>💪 Key Strengths</h5><p>{aiReport.key_strengths}</p></div></div>
            <div className="col-md-6"><div className="card p-3 shadow-sm"><h5>🔧 Areas To Improve</h5><p>{aiReport.areas_to_improve}</p></div></div>
          </div>

          {/* Home, Suggestions, Skills */}
          <div className="card p-3 shadow-sm mt-4"><h5>🏠 Recommended Home Activities</h5><p>{aiReport.home_activities}</p></div>
          <div className="card p-3 shadow-sm border-info mt-4"><h5>💡 Suggestions To Parents</h5><p>{aiReport.parent_suggestions}</p></div>
          <div className="card p-3 shadow-sm border-info mt-4"><h5>🧠 Skills Observed</h5><p>{aiReport.skills_observed}</p></div>

          {/* Therapist Style */}
          <div className="card p-3 shadow-sm border-success mt-4"><h5>👩‍⚕️ Therapist Interpretation Style</h5><p>{aiReport.therapist_style}</p></div>
          <div className="card p-3 shadow-sm border-success mt-4"><h5>👩‍⚕️ Session</h5><p>{aiReport.session_types_trend}</p></div>
        </div>
        </>
        )}
      </div>
    </div>
  );
};

export default ClientDashboardMain;
